import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTheme } from '@/theme/useTheme';

/**
 * Mount once near the root of the app. Auto-syncs with the current theme
 * via the existing ThemeProvider so colors stay consistent.
 */
export const Toaster = () => {
  const { theme } = useTheme();
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme={theme}
    />
  );
};
